export default {
  banks: (state) => {
    return state.banks;
  },
  bankMaxCode: (state) => {
    return state.bankMaxCode;
  },

  bankBranches: (state) => {
    return state.bankBranches;
  },
  branchMaxCode: (state) => {
    return state.branchMaxCode;
  },

  bankCashAccountInfo: (state) => {
    return state.bankCashAccountInfo;
  },
  bankCashAccountId: (state) => {
    return state.bankCashAccountId;
  },
  bankCashAccountInfoById: (state) => {
    return state.bankCashAccountInfoById;
  },
  bankCashAccountInfoVoucher: (state) => {
    return state.bankCashAccountInfoVoucher;
  },
  bankCashAccountInfoCode: (state) => {
    return state.bankCashAccountInfoCode;
  },
  chequeStatuses: (state) => {
    return state.chequeStatuses;
  },

  chequeBatch: (state) => {
    return state.chequeBatch;
  },
  chequeBatchCode: (state) => {
    return state.chequeBatchCode;
  },

  chequeBatchDetail: (state) => {
    return state.chequeBatchDetail;
  },

  receiveCashes: (state) => {
    return state.receiveCashes;
  },
  receiveCash: (state) => {
    return state.receiveCash;
  },

  receiveCashCode: (state) => {
    return state.receiveCashCode;
  },

  receiveCashNavigation: (state) => {
    return state.receiveCashNavigation;
  },

  receiveCashCheckDelete: (state) => {
    return state.receiveCashCheckDelete;
  },

  receiveCashVoucher: (state) => {
    return state.receiveCashVoucher;
  },

  paymentCashes: (state) => {
    return state.paymentCashes;
  },
  paymentCash: (state) => {
    return state.paymentCash;
  },

  paymentCashCode: (state) => {
    return state.paymentCashCode;
  },

  paymentCashNavigation: (state) => {
    return state.paymentCashNavigation;
  },

  paymentCashCheckDelete: (state) => {
    return state.paymentCashCheckDelete;
  },

  requestPayments: (state) => {
    return state.requestPayments;
  },
  requestPayment: (state) => {
    return state.requestPayment;
  },
  requestPaymentCode: (state) => {
    return state.requestPaymentCode;
  },
  requestPaymentNavigation: (state) => {
    return state.requestPaymentNavigation;
  },

  receiveCheques: (state) => {
    return state.receiveCheques;
  },
  receiveCheque: (state) => {
    return state.receiveCheque;
  },

  receiveChequeCode: (state) => {
    return state.receiveChequeCode;
  },

  receiveChequeBackNumber: (state) => {
    return state.receiveChequeBackNumber;
  },

  receiveChequeBankTransfer: (state) => {
    return state.receiveChequeBankTransfer;
  },

  transactionInfo: (state) => {
    return state.transactionInfo;
  },

  receiveChequeSampleExcel: (state) => {
    return state.receiveChequeSampleExcel;
  },

  receiveChequeCartable: (state) => {
    return state.receiveChequeCartable;
  },

  receiveChequeVoucher: (state) => {
    return state.receiveChequeVoucher;
  },

  receiveChequeNavigation: (state) => {
    return state.receiveChequeNavigation;
  },

  voucherTemplate: (state) => {
    return state.voucherTemplate;
  },

  bankTransfers: (state) => {
    return state.bankTransfers;
  },

  assignmentPersons: (state) => {
    return state.assignmentPersons;
  },

  settlements: (state) => {
    return state.settlements;
  },

  returnTransferreds: (state) => {
    return state.returnTransferreds;
  },

  cancellationReceivables: (state) => {
    return state.cancellationReceivables;
  },

  returnReceivables: (state) => {
    return state.returnReceivables;
  },

  returnGuarantees: (state) => {
    return state.returnGuarantees;
  },

  returnAssignments: (state) => {
    return state.returnAssignments;
  },

  requestPaymentConfirm: (state) => {
    return state.requestPaymentConfirm;
  },

  receiveChequeTurns: (state) => {
    return state.receiveChequeTurns;
  },
  receiveChequeTurn: (state) => {
    return state.receiveChequeTurn;
  },

  paymentCheques: (state) => {
    return state.paymentCheques;
  },
  paymentCheque: (state) => {
    return state.paymentCheque;
  },

  paymentChequeCode: (state) => {
    return state.paymentChequeCode;
  },

  paymentChequeTurns: (state) => {
    return state.paymentChequeTurns;
  },
  paymentChequeTurn: (state) => {
    return state.paymentChequeTurn;
  },

  paymentChequeNavigation: (state) => {
    return state.paymentChequeNavigation;
  },

  paymentChequeCartable: (state) => {
    return state.paymentChequeCartable;
  },

  paymentChequeCheckDelete: (state) => {
    return state.paymentChequeCheckDelete;
  },

  paymentChequeSampleExcel: (state) => {
    return state.paymentChequeSampleExcel;
  },

  paymentChequeVoucher: (state) => {
    return state.paymentChequeVoucher;
  },

  passPayDocs: (state) => {
    return state.passPayDocs;
  },

  cancelPayableDocs: (state) => {
    return state.cancelPayableDocs;
  },

  returnGuaranteeDocs: (state) => {
    return state.returnGuaranteeDocs;
  },

  receiveChequeReport: (state) => {
    return state.receiveChequeReport;
  },

  dueReceiveChequeReport: (state) => {
    return state.dueReceiveChequeReport;
  },

  monthlyComparisonReceiveChequeReport: (state) => {
    return state.MonthlyComparisonReceiveChequeReport;
  },

  receiveCashAndCahPaymentReport: (state) => {
    return state.receiveCashAndCahPaymentReport;
  },

  monthlyComparisonReceiveAndPaymentCashReport: (state) => {
    return state.monthlyComparisonReceiveAndPaymentCashReport;
  },

  historyReceiveChequeReport: (state) => {
    return state.historyReceiveChequeReport;
  },
  summaryReceiveChequeReport: (state) => {
    return state.summaryReceiveChequeReport;
  },

  paymentChequeReport: (state) => {
    return state.paymentChequeReport;
  },
  historyPaymentChequeReport: (state) => {
    return state.historyPaymentChequeReport;
  },
  monthlyComparisonPaymentChequeReport: (state) => {
    return state.monthlyComparisonPaymentChequeReport;
  },
  paymentChequeToPersonReport: (state) => {
    return state.paymentChequeToPersonReport;
  },
  paymentChequeToAccountInfoReport: (state) => {
    return state.paymentChequeToAccountInfoReport;
  },
  paymentChequeTurnReport: (state) => {
    return state.paymentChequeTurnReport;
  },
  summaryPaymentChequeReport: (state) => {
    return state.summaryPaymentChequeReport;
  },
  overduePaymentChequeReport: (state) => {
    return state.overduePaymentChequeReport;
  },

  circulationVoucherReport: (state) => {
    return state.circulationVoucherReport;
  },

  accountInventoryReport: (state) => {
    return state.accountInventoryReport;
  },
  summaryPaymentChequeTab: (state) => {
    return state.summaryPaymentChequeTab;
  },
  summaryReceiveChequeTab: (state) => {
    return state.summaryReceiveChequeTab;
  },
  summaryReceiveAndPaymentCash: (state) => {
    return state.summaryReceiveAndPaymentCash;
  },

  accountConfig: (state) => {
    return state.accountConfig;
  },

  accountInfo: (state) => {
    return state.accountInfo;
  },
  accountInfoCode: (state) => {
    return state.accountInfoCode;
  },

  lastAccount: (state) => {
    return state.lastAccount;
  },

  voucherNoteType: (state) => {
    return state.voucherNoteType;
  },

  defaultVoucherDescription: (state) => {
    return state.defaultVoucherDescription;
  },

  financialRatio: (state) => {
    return state.financialRatio;
  },
  financialRatioItem: (state) => {
    return state.financialRatioItem;
  },

  numerator: (state) => {
    return state.numerator;
  },
  denominator: (state) => {
    return state.denominator;
  },

  vouchers: (state) => {
    return state.vouchers;
  },

  vouchersTotalCount: (state) => {
    return state.vouchersTotalCount;
  },
  voucher: (state) => {
    if (state.voucher && state.voucher.voucherDetails) {
      state.voucher.voucherDetails.forEach((z) => {
        let found = state.accountInfo.find((i) => i.id == z.accountInfoId);
        z.accountInfoTitle = found.title;
        z.accountInfoCode = found.code;
      });
      return state.voucher;
    }
  },

  voucherNavigation: (state) => {
    return state.voucherNavigation;
  },

  voucherCheckCreate: (state) => {
    return state.voucherCheckCreate;
  },
  voucherCheckUpdate: (state) => {
    return state.voucherCheckUpdate;
  },

  voucherId: (state) => {
    return state.voucherId;
  },

  lastVoucherInfo: (state) => {
    return state.lastVoucherInfo;
  },

  voucherAttaches: (state) => {
    return state.voucherAttaches;
  },

  personCredits: (state) => {
    return state.personCredits;
  },

  userLimitAccounts: (state) => {
    return state.userLimitAccounts;
  },

  voucherNotes: (state) => {
    return state.voucherNotes;
  },

  confirmCartable: (state) => {
    return state.confirmCartable;
  },
  unConfirmCartable: (state) => {
    return state.unConfirmCartable;
  },

  voucherReview: (state) => {
    return state.voucherReview;
  },

  emptyVoucher: (state) => {
    return state.emptyVoucher;
  },

  archiveVoucher: (state) => {
    return state.archiveVoucher;
  },
  debtorOrCreditorDeclarations: (state) => {
    return state.debtorOrCreditorDeclarations;
  },
  debtorOrCreditorDeclaration: (state) => {
    return state.debtorOrCreditorDeclaration;
  },

  debtorOrCreditorDeclarationCode: (state) => {
    return state.debtorOrCreditorDeclarationCode;
  },

  debtorOrCreditorDeclarationNavigation: (state) => {
    return state.debtorOrCreditorDeclarationNavigation;
  },

  debtorOrCreditorDeclarationCheckDelete: (state) => {
    return state.debtorOrCreditorDeclarationCheckDelete;
  },

  // Static Getters ---------------------------------------------------------------
  voucehrOperationMenu() {
    return [
      {
        subItems: [{ value: 1, title: "مرتب سازی" }],
      },

      {
        subItems: [{ value: 2, title: "قطعی/غیرقطعی کردن " }],
      },
    ];
  },
  filterVoucherOptions() {
    return [
      { value: 1, text: "تاریخ سند" },
      { value: 2, text: "شماره سند" },
    ];
  },
};
